import styled, { useTheme } from 'styled-components';

export const LeftArrow = () => {
  const theme = useTheme();
  return (
    <Container data-testid="back-header-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M1 6L11 6"
          stroke={theme.palette.primary.main}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M5.54545 1.45459L1 6.00004"
          stroke={theme.palette.primary.main}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.54545 10.5454L1 5.99996"
          stroke={theme.palette.primary.main}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Container>
  );
};

const Container = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;
